export default __webpack_public_path__ + "static/media/thumsup.85312a8c.svg";